var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarsSolidBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "900.000000pt",
    height: "900.000000pt",
    viewBox: "0 0 900.000000 900.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2436 6479 c-72 -12 -167 -63 -216 -115 -23 -25 -56 -75 -73 -112 -29 -60 -32 -76 -31 -157 1 -117 26 -184 99 -263 61 -66 126 -105 205 -122 41 -8 580 -10 2115 -8 l2060 3 67 33 c85 41 167 128 199 209 17 44 23 79 23 148 1 81 -2 97 -31 157 -59 126 -164 206 -298 228 -74 12 -4047 12 -4119 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2404 4881 c-57 -14 -128 -56 -176 -104 -193 -192 -137 -513 110 -630 l67 -32 2100 0 2100 0 64 33 c81 43 146 110 185 192 28 59 31 74 31 160 -1 86 -4 102 -32 163 -39 81 -106 150 -189 192 l-59 30 -2085 2 c-1147 0 -2099 -2 -2116 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2399 3286 c-67 -18 -130 -58 -187 -121 -70 -77 -96 -145 -96 -260 0 -80 3 -97 31 -157 38 -81 95 -145 162 -182 108 -58 7 -56 2186 -56 1221 0 2023 4 2058 10 133 21 234 96 294 218 36 71 38 81 37 166 0 70 -6 105 -23 149 -32 81 -114 168 -199 209 l-67 33 -2075 2 c-1623 1 -2085 -1 -2121 -11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolidBlack);
export default __webpack_public_path__ + "static/media/bars-solid-black.24d12c34be41ec44b4e98e107f680195.svg";
export { ForwardRef as ReactComponent };